var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.st0{fill:#ff3131;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.4,42c0.4-0.4,0.8-0.6,1.3-0.6h46.4c0.8,0,1.3,1,0.7,1.6l-9.2,9.2c-0.4,0.4-0.8,0.6-1.3,0.6H1.9  c-0.8,0-1.3-1-0.7-1.6L10.4,42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.4,7.8c0.4-0.4,0.8-0.6,1.3-0.6h46.4c0.8,0,1.3,1,0.7,1.6L49.6,18c-0.4,0.4-0.8,0.6-1.3,0.6H1.9  c-0.8,0-1.3-1-0.7-1.6L10.4,7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.6,24.8c-0.4-0.4-0.8-0.6-1.3-0.6H1.9c-0.8,0-1.3,1-0.7,1.6l9.2,9.2c0.4,0.4,0.8,0.6,1.3,0.6h46.4  c0.8,0,1.3-1,0.7-1.6L49.6,24.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolana);
export default __webpack_public_path__ + "static/media/Solana.ae0f6537f2fd0da296d04ee2fe3ccf5f.svg";
export { ForwardRef as ReactComponent };